import React from "react";
import classes from "./tag.module.css";
import SecondaryButton, { SecondaryButtonProps } from "../SecondaryButton";

type IProps = {
  tag: string;
  count?: string | number;
} & SecondaryButtonProps

const Tag = ({ tag, count, ...props }: IProps) => {
  return (
    <SecondaryButton {...props}>
      <span>{tag}</span>
      { count && (
        <span className={classes.count}>&nbsp;{count}</span>
      )}
    </SecondaryButton>
  );
};

export default Tag;
